import React from 'react'
import aboutImg1 from '../imgs/about-img-1.png';
import aboutImg2 from '../imgs/about-img-2.png';
import aboutcircletext from '../imgs/about-video-text.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faArrowRight } from '@fortawesome/free-solid-svg-icons'


function about() {
    return (
        <section id='about' className='about'>
            <div className='container'>
                <div className='row mb-lg-0 mb-5'>
                    <div className='col-lg-6 col-12 py-lg-5 pb-5 mt-lg-5'>
                        <div className='heading-sec w-100 g-5 d-flex align-items-center justify-content-between'>
                            <div className='text-left pe-lg-5'>
                                <div className='strip-heading'>Get to Know Us</div>
                                <h2 className='h3-heading text-dark'>Unlock the potential of your business</h2>
                                <div className='h5-heading mb-3'>Inspired with Creativity & Space</div>
                                <p>Etiam sed odio dictum, tempus velit non, sollicitudin neque. Donec quis aliquet velit. Aliquam convallis dapibus purus. Etiam sed odio dictum, tempus velit non, sollicitudin neque.</p>
                                <a href='#' className='btn mt-3 btn-dark rounded-5'>Know More About Us <FontAwesomeIcon className='ms-2' icon={faArrowRight} /></a>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-12'>
                        <div className='d-flex align-items-center gap-3 right-sec'>
                            <img className='rounded-5 pb-lg-5 mb-lg-5' src={aboutImg1} alt="About Us 1" />
                            <img className='rounded-5 pt-lg-5 mt-lg-5' src={aboutImg2} alt="About Us 2" />
                            <div class="rotate-circle">
                                <div class="rotate spinner">
                                    <img className='rounded-5' src={aboutcircletext} alt="About Us 2" />
                                </div>
                                <a class="icon-button">
                                    <span class="d-inline-flex justify-content-center align-items-center">
                                        <FontAwesomeIcon icon={faPlay} />
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className='h5-heading mb-2 text-left text-dark'>Key Numbers That Count</div>
                    <p className='mb-4 text-left'>Combining passion with expertise to exceed expectations.</p>
                    <div className='row g-3'>
                    
                    <div className='col-lg-4'>
                        <div className='bg-light key-feature-card rounded-4 py-3 px-4'>
                            <div className='h3-heading mb-2 fw-700'>400+</div>
                            <div className='fs-5 fw-600 mb-md-3 mb-2'>Projects Completed Worldwide</div>
                            <p>Successfully delivered over 100 projects across various industries and global markets, showcasing our versatility and expertise.</p>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='bg-light key-feature-card rounded-4 py-3 px-4'>
                            <div className='h3-heading mb-2 fw-700'>98%</div>
                            <div className='fs-5 fw-600 mb-md-3 mb-2'>Client Satisfaction Rate</div>
                            <p>Our commitment to excellence is reflected in our high client satisfaction rate, with clients consistently praising our quality and service.</p>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='bg-light key-feature-card rounded-4 py-3 px-4'>
                            <div className='h3-heading mb-2 fw-700'>12+</div>
                            <div className='fs-5 fw-600 mb-md-3 mb-2'>Years of Experience</div>
                            <p>With over a decade of experience in the industry, we bring a wealth of knowledge and insights to every project.</p>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='bg-light key-feature-card rounded-4 py-3 px-4'>
                            <div className='h3-heading mb-2 fw-700'>50+</div>
                            <div className='fs-5 fw-600 mb-md-3 mb-2'>Industry Awards</div>
                            <p>Recognized for our innovative designs and outstanding performance, we have received numerous awards and accolades.</p>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='bg-light key-feature-card rounded-4 py-3 px-4'>
                            <div className='h3-heading mb-2 fw-700'>200+</div>
                            <div className='fs-5 fw-600 mb-md-3 mb-2'>Websites Launched</div>
                            <p>We've launched over 200 websites, each tailored to meet the unique needs of our clients and their audiences.</p>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='bg-light key-feature-card rounded-4 py-3 px-4'>
                            <div className='h3-heading mb-2 fw-700'>87%</div>
                            <div className='fs-5 fw-600 mb-md-3 mb-2'>Repeat Business Rate</div>
                            <p>Our clients trust us with their ongoing needs, resulting in a high rate of repeat business and long-term partnerships.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default about

